import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, Box, List, ListItem, ListItemText, Divider, ListItemIcon } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ListAltIcon from '@mui/icons-material/ListAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LogoutIcon from '@mui/icons-material/Logout';

export default function AdminDrawer({ open, onClose, goToAddNews, goToNewsList, goToSponsorManager }) {
  const navigate = useNavigate();
  const handleLogout = (e) => {
    e.stopPropagation();
    localStorage.removeItem('admin_uid');
    if (onClose) onClose();
    navigate('/admin/login');
  };

  const handleAddNews = () => {
    if (onClose) onClose();
    if (goToAddNews) goToAddNews();
  };
  const handleNewsList = () => {
    if (onClose) onClose();
    if (goToNewsList) goToNewsList();
  };
  const handleSponsorManager = () => {
    if (onClose) onClose();
    if (goToSponsorManager) goToSponsorManager();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 360, marginTop:3 }} role="presentation">
        <List>
          <ListItem button onClick={handleAddNews} sx={{ cursor: 'pointer' }}>
            <ListItemIcon>
              <AddCircleOutlineIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Adicionar Nova Notícia" />
          </ListItem>
          <Divider />
          <ListItem button onClick={handleNewsList} sx={{ cursor: 'pointer' }}>
            <ListItemIcon>
              <ListAltIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Lista de Notícias" />
          </ListItem>
          <Divider />
          <ListItem button onClick={handleSponsorManager} sx={{ cursor: 'pointer' }}>
            <ListItemIcon>
              <EmojiEventsIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Gerenciar Patrocinadores" />
          </ListItem>
          <Divider />
          <ListItem button onClick={handleLogout} sx={{ cursor: 'pointer' }}>
            <ListItemIcon>
              <LogoutIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}
